import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ToggleLabel, Toggle } from "./Toggle";
import { ToggleSwitch } from "./ToggleSwitch";
import { theme } from "../../theme";
import styled from 'styled-components';
export var Switch = React.forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
      _ref$visuallyHideLabe = _ref.visuallyHideLabel,
      visuallyHideLabel = _ref$visuallyHideLabe === void 0 ? false : _ref$visuallyHideLabe,
      block = _ref.block,
      other = _objectWithoutProperties(_ref, ["label", "visuallyHideLabel", "block"]);

  return /*#__PURE__*/React.createElement(Toggle, _extends({
    block: block
  }, other, {
    ref: forwardedRef
  }), label && /*#__PURE__*/React.createElement(StyledLabel, {
    visuallyHidden: visuallyHideLabel,
    $block: block
  }, label), /*#__PURE__*/React.createElement(ToggleSwitch, null));
});
var StyledLabel = styled(ToggleLabel).withConfig({
  displayName: "Switch__StyledLabel",
  componentId: "vapor__sc-1w6ntyf-0"
})(["margin-right:", ";"], function (p) {
  return p.$block ? 'auto' : theme.spaces[8];
});